import { useCallback, useRef, useState } from 'react'

import { QR_PANEL_STATUS } from '../constants'
import type { QrCancelSession, QrPanelState, QrStartSession } from '../types'

type UseQrManualRefreshParams = {
  status: QrPanelState['status']
  cancelCurrentSession: QrCancelSession
  startSession: QrStartSession
}

export const useQrManualRefresh = ({
  status,
  cancelCurrentSession,
  startSession
}: UseQrManualRefreshParams) => {
  const [isRefreshOverlayVisible, setIsRefreshOverlayVisible] = useState(false)
  const [isRefreshPending, setIsRefreshPending] = useState(false)
  const isRefreshPendingRef = useRef(false)

  const handleRefresh = useCallback(async () => {
    if (isRefreshPendingRef.current || status === QR_PANEL_STATUS.STARTING) {
      return
    }

    isRefreshPendingRef.current = true
    setIsRefreshPending(true)
    setIsRefreshOverlayVisible(true)
    cancelCurrentSession()

    try {
      await startSession()
    } finally {
      isRefreshPendingRef.current = false
      setIsRefreshPending(false)
      setIsRefreshOverlayVisible(false)
    }
  }, [cancelCurrentSession, startSession, status])

  return {
    isRefreshOverlayVisible,
    isRefreshPending,
    handleRefresh
  }
}
